// Auto-generated by build-comment-action-sprite.js
export const SPRITE_VERSION = "f4f4b2de";
